import { ConsultantLoadingPanel } from './ConsultantLoadingPanel';
import './LandingGuestQuestionComposer.css';
import './LandingGuestQuestionWaiting.css';

export function LandingGuestQuestionWaiting({ isOpen, previewElapsedSeconds }: { isOpen: boolean; previewElapsedSeconds?: number }) {
  return (
    <section
      aria-labelledby="guest-question-waiting-title"
      aria-hidden={!isOpen}
      data-guest-question-waiting
      className="guest-question-waiting-panel landing-guest-composer relative min-w-0 rounded-[1.75rem] px-4 py-7 sm:px-6 sm:py-8"
    >
      <ConsultantLoadingPanel isStreaming={false} isActive={isOpen} previewElapsedSeconds={previewElapsedSeconds} titleId="guest-question-waiting-title" />
    </section>
  );
}
